import { PlaylistParserDecryptStage } from '@streamLoader/PlaylistDecrypt/PlaylistParsers/PlaylistParserDecryptStage';
import { V1PostParseURLRestore } from '@streamLoader/PlaylistDecrypt/PlaylistValidators/V1Scheme/Decryptors/V1PostParseURLRestore/V1PostParseURLRestore';
import { V1PreParseURLRestore } from '@streamLoader/PlaylistDecrypt/PlaylistValidators/V1Scheme/Decryptors/V1PreParseURLRestore/V1PreParseURLRestore';

export const SCHEME_MAP: Record<string, PlaylistParserDecryptStage[]> = {
  v1: [new V1PostParseURLRestore(), new V1PreParseURLRestore()],
};
